import { useContext } from 'react';
import { NotifierContext } from './NotifierContext';

export const useNotifications = () => {
  const { add } = useContext(NotifierContext);

  return add;
};
